<section class="order-container" id="onetriggersanother-order">
  <div class="row">
    <div class="row">
      <div class="left">
        <div class="title-name">Títulos</div>
      </div>
      <div class="right">
        <div class="title-name">Duración</div>
      </div>
    </div>
    <div
      punchPicker
      [placeholder]="'Títulos'"
      [isTitles]="true"
      (items)="setTitles($event)"
      [sentValue]="titles"
      data-recording-ignore="mask"
    ></div>
    <div
      class="combo-select-wrapper enlinea"
      *ngIf="canModifyDuration === true"
    >
      <combo-select
        class="duration small"
        [sentSelected]="defaultDuration"
        [resultsList]="vigencia"
        [title]="'Duración'"
        (emitSelectedItem)="setDuration($event)"
      >
      </combo-select>
    </div>
    <div class="hard-section" *ngIf="canModifyDuration === false">
      <div class="subtitle">1 día</div>
    </div>
  </div>
  <div class="row">
    <div class="row">
      <div class="left">
        <div class="title-name">Precio</div>
      </div>
    </div>
    <div
      class="left"
      [class]="'prc-objetivo'"
      [placeholder]="'Precio'"
      punchPicker
      [sentValue]="selectedPrice"
      [isPrice]="true"
      (items)="setPrice($event)"
      [minValue]="0"
      data-recording-ignore="mask"
    ></div>
  </div>
  <div class="row title">
    <div class="checkbox">
      <input
        type="checkbox"
        (click)="togglePrecioObjetivoOCA()"
        checked
        id="precio-objetivo"
        class="input-check"
      />
      <label class="label-check" for="precio-objetivo">
        <span class="square"></span>
        Precio objetivo
      </label>
    </div>
  </div>
  <div class="row" *ngIf="showPrecioObjetivo === true">
    <div
      class="left"
      [class]="'prc-objetivo-oca'"
      [placeholder]="'Precio'"
      punchPicker
      [isPrice]="true"
      (items)="setPriceOCA($event)"
      [minValue]="0"
      data-recording-ignore="mask"
    ></div>
  </div>
  <div class="row title">
    <div class="checkbox">
      <input
        type="checkbox"
        (click)="toggleStopLoss()"
        checked
        id="stop-loss"
        class="input-check"
      />
      <label class="label-check" for="stop-loss">
        <span class="square"></span>
        Stop loss
      </label>
    </div>
  </div>
  <div class="row" *ngIf="showStopLoss === true">
    <div class="row">
      <div class="left">
        <div class="title-name">Tipo de operación</div>
      </div>
    </div>
    <combo-select
      class="tipo-operacion"
      [resultsList]="ordenType"
      [title]="'Tipo de Operación'"
      (emitSelectedItem)="setIntraOrderType($event)"
    ></combo-select>

    <div class="orders-container">
      <section
        *ngIf="selectedOrder.id == 8"
        class="order-container"
        id="stopenlinea-order"
      >
        <div class="row">
          <div class="row">
            <div class="left">
              <div class="title-name">Precio stop</div>
            </div>
          </div>
          <div
            punchPicker
            [class]="'prc-stop prc-stop-enlinea'"
            [placeholder]="'Precio stop'"
            class="left"
            [isPrice]="true"
            (items)="setPriceStop($event)"
            [minValue]="0"
            data-recording-ignore="mask"
          ></div>
        </div>
      </section>

      <section
        *ngIf="selectedOrder.id == 9"
        class="order-container"
        id="stoplimitado-order"
      >
        <div class="row">
          <div class="row">
            <div class="left">
              <div class="title-name">Precio stop</div>
            </div>
            <div class="right precio-limite">
              <div class="title-name">Precio límite</div>
            </div>
          </div>
          <div
            [class]="'prc-limite stop-limite-stoplimitado'"
            [placeholder]="'Precio límite'"
            punchPicker
            [isPrice]="true"
            (items)="setPriceLimit($event)"
            [minValue]="0"
            data-recording-ignore="mask"
          ></div>
          <div
            [class]="'prc-stop prc-stop-stoplimitado'"
            [placeholder]="'Precio stop'"
            punchPicker
            [isPrice]="true"
            (items)="setPriceStop($event)"
            [minValue]="0"
            data-recording-ignore="mask"
          ></div>
        </div>
      </section>

      <section
        *ngIf="selectedOrder.id == 10"
        class="order-container"
        id="trailingstop-order"
      >
        <div class="row">
          <div class="row">
            <div class="left">
              <div class="title-name">Porcentaje</div>
            </div>
          </div>
          <div
            [class]="'porcentaje'"
            [placeholder]="'Porcentaje'"
            punchPicker
            class="left"
            [isPercentage]="true"
            (items)="setPorcentaje($event)"
            [stepsIncrement]="5"
            [maxValue]="100"
            [minValue]="0"
          ></div>
        </div>
      </section>
    </div>
  </div>

  <div class="actions" *ngIf="canOperate && !isDiscretional">
    <button (click)="tryBuy()" class="btn-compra">
      <div class="button button--loading" *ngIf="isBuyButtonLoading">
        <div class="button__loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      {{ isBuyButtonLoading ? '' : 'Comprar' }}
    </button>
    <button (click)="trySell()" class="btn-venta">
      <div class="button button--loading" *ngIf="isSellButtonLoading">
        <div class="button__loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      {{ isSellButtonLoading ? '' : 'Vender' }}
    </button>
  </div>
</section>

<app-confirmation-modal
  [order]="confirmationOrder"
  (onClose)="cancelConfirmation()"
  (confirmationHandler)="registerOrder()"
  *ngIf="showConfirmation"
>
</app-confirmation-modal>
